export const SOLUTIONS_RESOURCE_URL = 'https://eu8-cloud.acronis.com/api/platform-web-assets/public/s3';
